import React from 'react';
import { Box, Flex, TextV2, Toggle } from '@withjoy/joykit';
import { styles } from '../../CashFundPaymentMethod.style';
import { useSharedRegistryTranslations } from '@apps/registry/SharedRegistry.i18n';
import { FormikProps } from 'formik';
import { AddCashFundDialogFields } from '../../../../types';

interface CashOrCheckToggleProps {
  formik: FormikProps<AddCashFundDialogFields>;
}
export const CashOrCheckToggle: React.FC<CashOrCheckToggleProps> = ({ formik }) => {
  const { getCashFundDialogTranslations } = useSharedRegistryTranslations();

  const { enableCashOrCheckText, enableCashOrCheckDescription } = getCashFundDialogTranslations();

  return (
    <Flex __css={styles.toggleWrapper()}>
      <Box>
        <Flex alignItems="center">
          <TextV2 typographyVariant="hed1">{enableCashOrCheckText}</TextV2>
        </Flex>
        <TextV2
          typographyVariant="label2"
          color="mono12"
        >
          {enableCashOrCheckDescription}
        </TextV2>
      </Box>
      <Flex justifyContent="center">
        <Toggle
          label=""
          intent="primary"
          hideLabel={true}
          checked={formik.values.enableCashOrCheck}
          name="enableCashOrCheck"
          onChange={formik.handleChange}
        />
      </Flex>
    </Flex>
  );
};
